<div class="table">
  <div class="table-header">
    <div class="table-info">
      <div class="table-title">{{ tableConfig?.title }}</div>
      <ng-container *ngIf="!isLoading; else resultLoadingContent">
        <p class="table-count" *ngIf="tableConfig?.id === 'manage-oaa-existing'; else resultCount">
          <em>{{ tableContent?.length || 0 }} of {{ metaInfo?.maxOaaCount }} Assigned</em>
        </p>
        <ng-template #resultCount>
          <p class="table-count">
            <em>{{ tableContent?.length || 0 }} {{ tableContent?.length === 1 ? resultText : resultTextPlural }}</em>
          </p>
        </ng-template>
      </ng-container>
      <ng-template #resultLoadingContent>
        <app-pol-loader
          skeletonSize="'large'"
          skeletonStyle="'none'"
          [skeletonType]="'text'"
          [skeletonRows]="1"
          [skeletonTitle]="false"
          [skeletonFooter]="false"
          [skeletonAlignment]="'aligned'"
        ></app-pol-loader>
      </ng-template>
    </div>
    <div class="table-filter">
      <div class="table-actions">
        <ods-button
          variant="tertiary"
          *ngIf="tableConfig?.headerAction"
          [disabled]="isHeaderActionDisabled"
          class="header-action-btn"
          (click)="handleHeaderActionClick(tableConfig?.headerAction?.action)"
          id="addNewUserBtn"
          role="link"
        >
          {{ tableConfig?.headerAction?.label }}
        </ods-button>
        <ods-select
          *ngIf="!disablePagination"
          aria-label="select page size"
          id="paginationDropdown"
          [disabled]="!displayedTableContent || !tableContent?.length || tableContent?.length < tableConfig?.pageSize"
          [value]="tableConfig?.pageSize?.toString()"
          (change)="handlePageChange(currentPage, $event.target.value)"
        >
          <ods-select-option *ngFor="let option of paginationRowOptions" [value]="option.value">
            {{ option.label }}
          </ods-select-option>
        </ods-select>
      </div>
    </div>
  </div>

  <div class="table-container scrollbox">
    <table [ngClass]="tableConfig?.id" [attr.id]="'tableContainer' + tableConfig?.id">
      <thead>
        <tr>
          <th *ngIf="tableConfig.isExpandable" class="expand-header"></th>
          <th *ngIf="tableConfig.selectable" class="select-header">
            <input
              type="checkbox"
              id="{{ tableConfig.id }}-selectAll"
              class="ods-checkbox"
              [checked]="isSelectAll"
              (change)="selectAll($event.target.checked)"
              aria-label="Select all"
            />
          </th>
          <th class="table-radio-header" *ngIf="tableConfig?.radioConfig">{{ tableConfig?.radioConfig?.title }}</th>
          <ng-container *ngFor="let column of tableConfig?.columns">
            <th [ngClass]="'col-' + column.dataProperty" [style.width]="column.width">
              <button
                *ngIf="column.sortable"
                (click)="sort(column.dataProperty)"
                [attr.name]="'sort' + column.dataProperty"
                [attr.id]="column.dataProperty + 'SortBtn'"
              >
                {{ column.title }}
                <img [src]="getSortIndicator(column.dataProperty)" aria-label="sort arrows" alt="" />
              </button>
              <span *ngIf="!column.sortable">
                {{ column.title }}
              </span>
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="!isLoading; else searchLoadingContent">
          <ng-container *ngIf="displayedTableContent?.length > 0">
            <ng-container *ngFor="let columnData of displayedTableContent; let i = index">
              <tr #dataRow>
                <td class="table-radio-cell" *ngIf="tableConfig?.radioConfig">
                  <input
                    #rowRadioSelect
                    type="radio"
                    name="selectedRow-{{ tableConfig.id }}"
                    [value]="columnData[tableConfig?.radioConfig?.dataProperty]"
                    [attr.aria-label]="tableConfig?.radioConfig?.ariaLabel(columnData)"
                    (change)="onRadioSelect(columnData)"
                    tabindex="0"
                    [disabled]="tableConfig?.radioConfig.isDisabled() ? true : undefined"
                  />
                </td>
                <td *ngIf="tableConfig.isExpandable">
                  <img
                    tabindex="0"
                    class="expand-row"
                    [ngClass]="{ expanded: columnData.isExpanded, collapsed: !columnData.isExpanded }"
                    src="/assets/images/icons/arrow_up_thick.svg"
                    alt=""
                    [attr.aria-label]="columnData.isExpanded ? tableConfig.expansionOptions?.getExpandedAriaLabel(columnData) : tableConfig.expansionOptions?.getCollapsedAriaLabel(columnData)"
                    role="button"
                    [attr.aria-expanded]="columnData.isExpanded"
                    (click)="toggleRowClicked(i, columnData.isExpanded)"
                    (keypress)="toggleRowClicked(i, columnData.isExpanded)">
                </td>
                <td *ngIf="tableConfig.selectable">
                  <input type="checkbox" class="ods-checkbox"
                    id="{{ tableConfig.id }}-checkBox{{ i }}"
                    [checked]="tableContent[i].isChecked || false"
                    (change)="selectRow(i, $event.target.checked)"
                    [attr.aria-label]="columnData[selectAriaLabelProperty]"
                    tabindex="0"
                  />
                </td>
                <ng-container *ngFor="let columnHead of tableConfig?.columns; let columnIndex = index">
                  <td
                    *ngIf="(columnData.action === false || columnData.isvipMasked === true) && columnHead.restrictedStart; else unrestricted"
                    [attr.colspan]="columnHead.colSpan"
                  >
                    <span class="restricted-banner">Restricted Access</span>
                  </td>
                  <ng-template #unrestricted>
                    <td *ngIf="columnData.action === true || columnData.isvipMasked === false || !columnHead.hideRestricted">
                      <!-- most table cells -->
                      <span
                        *ngIf="
                          columnHead.dataProperty !== 'address' &&
                          columnHead.dataProperty !== 'action' &&
                          columnHead.dataProperty !== 'custom-action' &&
                          (columnHead.dataProperty !== 'memberId' || tableConfig?.id !== 'member-lookup')
                      ">
                        {{ columnData[columnHead.dataProperty] || columnHead.placeholder }}
                      </span>
                      <!-- member-lookup table cell -->
                      <ng-container *ngIf="tableConfig?.id === 'member-lookup'">
                        <div *ngIf="columnHead.dataProperty === 'memberId'">
                          <div *ngIf="columnData.action === false || columnData.isvipMasked">
                            <div class="tooltip isTooltipActive"><img class="lock_icon" src="/assets/images/icons/locked.svg" alt="Restricted">Restricted</div>
                            <div class="tooltip-text">
                              <span>You do not have access to view this member's information.</span>
                              <br>
                              <span>Please contact your OAA if access is required.</span>
                            </div>
                          </div>
                          <div *ngIf="columnData.action === true || columnData.isvipMasked === false">
                            {{ columnData[columnHead.dataProperty] || columnHead.placeholder }}
                          </div>
                        </div>
                      </ng-container>
                      <!-- address table cell -->
                      <ng-container *ngIf="columnHead.dataProperty === 'address'">
                        <div class="tooltip" appOverflowTooltip>
                          {{ columnData.addressLine1 }} <br *ngIf="columnData?.addressLine2" />
                          {{ columnData.addressLine2 }} <br />
                          {{ columnData.city }}, {{ columnData.state }} {{ columnData.zipCode }}
                        </div>
                        <div class="tooltip-text">
                          <span>{{ columnData.addressLine1 }}</span> <br *ngIf="columnData?.addressLine2" />
                          <span *ngIf="columnData?.addressLine2">{{ columnData.addressLine2 }}</span> <br />
                          <span>{{ columnData.city }}, {{ columnData.state }} {{ columnData.zipCode }}</span>
                        </div>
                      </ng-container>
                      <!-- action table cell -->
                      <ng-container *ngIf="columnHead.dataProperty === 'action'">
                        <ng-container [ngSwitch]="tableConfig.id">
                          <ng-container *ngSwitchCase="'member-lookup'">
                            <div class="actions-wrapper">
                              <a
                                [href]="'#viewUserBtn' + (i + 1)"
                                [attr.aria-label]="'View ' +  columnData.firstName + ' ' + columnData.lastName"
                                class="btn-link view-button"
                                [ngClass]="{'disabled' : !columnData.action}"
                                [attr.aria-disabled]="!columnData.action"
                                (click)="handleAction1Click($event, columnData.memberId, !columnData.action)"
                                (keypress)="handleAction1Click($event, columnData.memberId, !columnData.action)"
                                [attr.id]="'viewUserBtn' + (i + 1)"
                              >
                                View
                              </a>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'add-user'">
                            <div class="actions-wrapper">
                              <a
                                [attr.href]="!columnData.added ? '#addUserBtn' + (i + 1) : null"
                                [attr.role]="columnData.added ? 'link' : null"
                                [attr.aria-label]="'Add user ' +  columnData.firstName + ' ' + columnData.lastName"
                                class="btn-link view-button" [ngClass]="{'disabled' : columnData.added}"
                                [attr.aria-disabled]="columnData.added ? true : null"
                                (click)="handleAction1Click($event, columnData.userId, columnData.added)"
                                (keypress)="handleAction1Click($event, columnData.userId, columnData.added)"
                                [attr.id]="'addUserBtn' + (i + 1)"
                              >
                                Add User
                              </a>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'edit-user'">
                            <div class="actions-wrapper">
                              <a
                                [href]="'#editUserBtn' + (i + 1)"
                                [attr.aria-label]="'Edit ' +  columnData.firstName + ' ' + columnData.lastName"
                                class="btn-link view-button"
                                (click)="handleAction1Click($event, columnData)"
                                (keypress)="handleAction1Click($event, columnData)"
                                [attr.id]="'editUserBtn' + (i + 1)"
                              >
                                Edit
                              </a>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="['manage-oaa-existing', 'favorite-providers'].includes(tableConfig.id) ? tableConfig.id : ''">
                            <div class="actions-wrapper">
                              <button
                                [attr.aria-label]="'Remove ' +  columnData.firstName + ' ' + columnData.lastName"
                                class="btn-link view-button"
                                (click)="handleAction1Click($event, columnData)"
                                (keypress)="handleAction1Click($event, columnData)"
                                [attr.id]="'removeUserBtn' + (i + 1)"
                              >
                                Remove
                              </button>
                              <a
                                *ngIf="tableConfig?.id === 'manage-oaa-existing'"
                                [href]="'#replaceUserBtn' + (i + 1)"
                                [attr.aria-label]="'Replace ' +  columnData.firstName + ' ' + columnData.lastName"
                                class="btn-link view-button"
                                (click)="handleAction2Click($event, columnData)"
                                (keypress)="handleAction2Click($event, columnData)"
                                [id]="'replaceUserBtn' + (i + 1)"
                              >
                                Replace
                              </a>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'manage-oaa-search'">
                            <div class="actions-wrapper">
                              <button
                              [attr.aria-label]="'Assign OAA ' +  columnData.firstName + ' ' + columnData.lastName"
                                class="btn-link view-button"
                                [disabled]="columnData.isOaa === 'true'"
                                (click)="handleAction1Click($event, columnData)"
                                (keypress)="handleAction1Click($event, columnData)"
                                [attr.id]="'assignOaaBtn' + (i + 1)"
                              >
                                Assign OAA
                              </button>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'auth-entry-search'">
                            <div class="actions-wrapper">
                              <button
                                *ngIf="columnData.isEligible; else inEligibleBtn"
                                class="btn-link view-button"
                                (click)="handleAction1Click($event, columnData)"
                                (keypress)="handleAction1Click($event, columnData)"
                                [attr.id]="'eligible-action-' + (i + 1 )"
                              >
                                Eligible
                              </button>
                              <ng-template #inEligibleBtn>
                                <button
                                  class="btn-link view-button"
                                  (click)="handleAction2Click($event, columnData)"
                                  (keypress)="handleAction2Click($event, columnData)"
                                  [attr.id]="'in-eligible-action-' + (i + 1)"
                                >
                                  Ineligible
                                </button>
                              </ng-template>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchDefault>

                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="columnHead.action">
                        <div class="actions-wrapper custom-actions">
                          <ods-link
                            *ngIf="columnHead.action.text; else iconAction"
                            [class.disabled]="columnHead.action.disabled && columnHead.action.disabled(columnData)"
                            [dataDisabled]="columnHead.action.disabled && columnHead.action.disabled(columnData)"
                            [attr.id]="tableConfig?.id + '-actionBtn' + i"
                            (click)="columnHead.action.callback($event, columnData)"
                            (keypress)="columnHead.action.callback($event, columnData)"
                            [attr.aria-label]="'Select ' + columnData.name"
                            role="button"
                          >
                            {{ columnHead.action.text }}
                          </ods-link>
                          <ng-template #iconAction>
                            <ods-link
                            [class.disabled]="columnHead.action.disabled && columnHead.action.disabled(columnData)"
                              [dataDisabled]="columnHead.action.disabled && columnHead.action.disabled(columnData)"
                              [attr.id]="tableConfig?.id + '-actionBtn' + i"
                              (click)="columnHead.action.callback($event, columnData)"
                              (keypress)="columnHead.action.callback($event, columnData)"
                              [attr.aria-label]="columnHead.action.ariaLabel(columnData)"
                              role="button"
                            >
                            <ods-icon slot="icon" variant="trash"></ods-icon>
                          </ods-link>
                          </ng-template>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="columnHead.actionComputed">
                        <div class="actions-wrapper custom-actions">
                          <ods-link
                            [class.disabled]="columnHead.action.disabled && columnHead.action.disabled(columnData)"
                            [dataDisabled]="columnHead.actionComputed(columnData).disabled(columnData)"
                            [attr.id]="tableConfig?.id + '-actionBtn' + i"
                            (click)="columnHead.actionComputed(columnData).callback($event, columnData)"
                            (keypress)="columnHead.actionComputed(columnData).callback($event, columnData)"
                            [attr.aria-label]="'Select ' + columnData.name"
                            role="button"
                          >
                            {{ columnHead.actionComputed(columnData).text }}
                          </ods-link>
                        </div>
                      </ng-container>
                      <!-- overflow actions -->
                      <ng-container *ngIf="columnHead.overflowActions?.length > 0">
                        <app-overflow-menu
                          icon="/assets/images/icons/more.svg"
                          [config]="columnHead.overflowActions"
                          [metadata]="columnData"
                          [ariaLabel]="columnHead.overflowActionsAriaLabel(columnData)"
                        ></app-overflow-menu>
                      </ng-container>
                      <ng-container *ngIf="columnHead.overflowActionsComputed">
                        <app-overflow-menu
                          icon="/assets/images/icons/more.svg"
                          [config]="columnHead.overflowActionsComputed(columnData)"
                          [metadata]="columnData"
                          [ariaLabel]="columnHead.overflowActionsAriaLabel(columnData)"
                        ></app-overflow-menu>
                      </ng-container>

                    </td>
                  </ng-template>
                </ng-container>
                <div *ngIf="columnData[tableConfig.infoMessageProperty]" class="info-message">
                  <img src="/assets/images/icons/info.svg" alt="info">
                  <h5>{{ columnData[tableConfig.infoMessageProperty] }}</h5>
                </div>
              </tr>
              <!-- sub tables -->
              <ng-container *ngIf="columnData.isExpanded">
                <tr *ngFor="let subTable of tableConfig.subTables; let tableIndex = index">
                  <td [attr.colspan]="tableConfig.columns.length + 1" class="sub-table-container">
                    <table class="sub-table {{ subTable?.class }}" [ngClass]="{ 'view-more-enabled': subTable.enableViewMore && columnData[subTable.viewMoreProperty] > subTable.viewMoreThreshold }">
                      <thead>
                        <tr>
                          <th *ngIf="subTable.isExpandable">
                            <img
                              tabindex="0"
                              class="expand-row"
                              [ngClass]="{ expanded: subTable.isExpanded, collapsed: !subTable.isExpanded }"
                              src="/assets/images/icons/arrow_up_thick.svg"
                              alt=""
                              [attr.aria-label]="subTable.isExpanded ? subTable.expansionOptions?.getExpandedAriaLabel(columnData) : subTable.expansionOptions?.getCollapsedAriaLabel(columnData)"
                              [attr.aria-expanded]="subTable.isExpanded"
                              role="button"
                              (click)="toggleSubRowClicked(tableIndex)"
                              (keypress)="toggleSubRowClicked(tableIndex)">
                          </th>
                          <!-- check for header templates -->
                          <ng-container *ngIf="headerTemplates.get(tableIndex) as tmpl; else defaultHeader">
                            <ng-template *ngTemplateOutlet="tmpl; context: { $implicit: columnData }"></ng-template>
                          </ng-container>
                          <ng-template #defaultHeader>
                            <th *ngFor="let subColumn of subTable.columns">
                              {{ subTable.title }}
                            </th>
                          </ng-template>
                        </tr>
                      </thead>
                      <tbody *ngIf="subTable.isExpanded">
                        <ng-container *ngFor="let subColumn of subTable.columns; let subIndex = index">
                          <tr *ngFor="let rows of sliceViewMore(columnData[subColumn.dataProperty], subTable)">
                            <td *ngIf="subTable.isExpandable"></td>
                            <!-- check for body templates -->
                            <ng-container *ngIf="bodyTemplates.get(tableIndex) as tmpl; else defaultBody">
                              <ng-template *ngTemplateOutlet="tmpl; context: { $implicit: rows }"></ng-template>
                            </ng-container>
                            <ng-template #defaultBody>
                              <td *ngFor="let row of rows">
                                {{ row }}
                              </td>
                            </ng-template>
                          </tr>
                        </ng-container>
                        <ods-view-more-less
                        *ngIf="subTable.enableViewMore && columnData[subTable.viewMoreProperty] > subTable.viewMoreThreshold"
                        (click)="toggleViewMore(subTable)"
                      ></ods-view-more-less>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div *ngIf="(!tableContent || !tableContent.length) && !isLoading" class="table-message">
    {{ !tableContent ? tableConfig?.initialMessage : tableConfig?.emptyMessage }}
  </div>

  <div class="pagination-container" *ngIf="!disablePagination && numOfPages && tableContent.length > tableConfig?.pageSize">
    <app-pagination
      [numOfPages]="numOfPages"
      [currentPage]="currentPage"
      (isChangePage)="handlePageChange($event, pageSize)"
    >
    </app-pagination>
  </div>

  <!-- Loading Content -->
  <ng-template #searchLoadingContent>
    <tr *ngFor="let row of [0, 1, 2]" class="loading-row">
      <td *ngFor="let columnHead of tableConfig?.columns">
        <app-pol-loader
          skeletonSize="large"
          [skeletonType]="'text'"
          [skeletonRows]="1"
          [skeletonTitle]="false"
          [skeletonFooter]="false"
          skeletonAlignment="aligned"
          skeletonStyle="none"
        />
      </td>
    </tr>
  </ng-template>
</div>
